import { down } from 'styled-breakpoints';
import { createGlobalStyle } from 'styled-components';

export const LayoutGlobalStyle = createGlobalStyle`
 // Form personalizzato per ant (label)
 .form-handler {
  // fix antd form item label 5.21.0
  &.ant-form.ant-form-vertical {
    .ant-form-item-label {
      padding: 0;
      margin: 0;
      margin-top: -9px;
    }
  }

 }
 .form-handler {
   .ant-form-item {
      position: relative;
      padding-top: 8px;

      // Label Material Stile
      .ant-form-item-label {
        position: absolute;
        z-index: 2;
        padding: 0;
        right: 8px;
        left: 8px;
        margin-top: -9px;
        height: 18px;
        pointer-events: none;

        > label {
          font-size: 12px;
          padding: 0 4px;
          background-color: #fff;
          color: ${props => props.theme.colorText};
          pointer-events: visible;

          // Text ellipsis overflow
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          &.ant-form-item-required::before {
            margin-inline-end: 0.1em;
          }
          &:after {
            content: unset;
          }
        }
      }

      // Stili per messaggi di errore e aiuto
      .ant-form-item-extra {
        font-size: 13px;
        line-height: 1.5;
        color: ${props => props.theme.colorTextSecondary};
        min-height: 0px;
      }
      .ant-form-item-explain {
        font-size: 13px;
        line-height: 1.5;
        /* color: ${props => props.theme.colorTextSecondary}; */
        + div {
          height: auto !important;
        }
      }

      // Radio e Checkbox per evitare sovrapposizione con label
      .ant-radio-wrapper,
      .ant-checkbox-wrapper {
        margin-top: 10px;
        // dopo l'iinserimento dell'altezza minima (.ant-form-item-control-input)
        /* margin-top: 2px; */
      }
      .ant-checkbox-wrapper {
        margin-inline-end: 8px;
        + .ant-checkbox-wrapper {
          margin-inline-start: 0;
        }
      }


    // Correzione spazio help quando è presente anche un errore
    &.ant-form-item-with-help {
      &.ant-form-item-has-error {
        .ant-form-item-extra {
          margin-bottom: 12px;
        }
      }
    }


      //  CheckboxInput.ts
      /* .ant-checkbox-wrapper {
        &.checkbox-not-editable {
          cursor: default;
          input,
          .ant-checkbox-checked {
            cursor: default;
          }
          .ant-checkbox-inner,
          .ant-checkbox-inner:hover {
            border: 1px solid rgba(23, 50, 77, 0.1);
            cursor: default;
          }
        }
      } */

      // TextAreaInputItem
      /*
      body {
        .text-area-input-item {
          .ant-form-item-control-wrapper {
            .ant-form-item-children {
              position: static;
              textarea {
                margin-bottom: 0;
              }
            }
          }
        }
      }*/
      
      .ant-checkbox-group {
        /* margin-top: 8px; */
      }
      // per posizionare alla stessa altezza il messaggio di errore / aiuto 
      // per i checkbox e radio se i campi vicini sono LARGE
      // verificare se è necessario per le altre grandezze
      .ant-form-item-control-input-content {
        /* min-height: 40px; */
      }
   }
 }

 // fix colote Empty per accessibilità
 .ant-empty .ant-empty-description{
  color: ${props => props.theme.colorTextSecondary};
 }

 // fix colori placeholder disabilitato
 // testato sui seguenti tipi
 .ant-select-disabled
  .ant-select-selection-placeholder {
    color: ${props => props.theme.colorTextPlaceholderDisabled};
  }
  .ant-input-disabled {
    &input::placeholder {
      color: ${props => props.theme.colorTextPlaceholderDisabled};
    }
  }
  .ant-input-disabled,
  .ant-picker-disabled {
    input::placeholder {
      color: ${props => props.theme.colorTextPlaceholderDisabled} !important;
    }
  }

 // A11Y fix contrasto ant tag green Accessibilità
 .ant-tag.ant-tag-green {
    color: #236407;
    background: #f6ffed;
    border-color: #b7eb8f;
 }
 
 // Evidenzazione riga al passaggio del mouse
 .ant-table:not(.ant-table-bordered) {
  .ant-table-tbody {
      > tr.ant-table-row  {
        // Modifica Corsore, Sfondo e Bordi 
        &:hover,
        &.ant-table-row-selected {          

          > td.ant-table-cell-row-hover {
            background-color: ${props => props.theme.controlItemBgHover};
            border-top-color: ${props => props.theme.colorFillTertiary};
          }
          // Modifica Bordo riga successiva
          + tr.ant-table-row > td.ant-table-cell {
            border-top-color: ${props => props.theme.colorFillSecondary};
          }
        }
        // Modifica Bordo in caso ultima riga
        &:last-child:hover > td.ant-table-cell-row-hover {
          border-bottom-color: ${props => props.theme.colorFillTertiary};
        }
        // Fix bordo superiore arrotondato in caso di selezione riga (non so perchè è così in antd)
        &:hover,
        &.ant-table-row-selected {
          >td.ant-table-cell-row-hover:first-child {
            border-start-start-radius: 0;
            border-end-start-radius: 0;
          }
          >td.ant-table-cell-row-hover:last-child {
            border-start-end-radius: 0;
            border-end-end-radius: 0;
        }
      }

   }
 }
}

// Accessibilità Dropdown
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item,
.ant-dropdown-menu-submenu .ant-dropdown-menu .ant-dropdown-menu-item, 
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu-title, 
.ant-dropdown-menu-submenu .ant-dropdown-menu .ant-dropdown-menu-submenu-title { 
  &:focus-visible {
    outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor} !important; //#bfc7de  
      outline-offset: 0px;
  }
}
.ant-collapse-header {
  &:focus-visible {
    outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor} !important; //#bfc7de  
        outline-offset: -5px;
  }
}

  /* ant-select-item ant-select-item-option ant-select-item-option-active */
  // Accessibilità , modifica del focus (vedi sotto -> genFocusOutline())
.ant-btn:not(:disabled), // Pulsanti
.ant-breadcrumb a, // Breadcrumb
.ant-switch:not(:disabled),
.ant-tabs .ant-tabs-tab-btn { // Tabs
    &:focus-visible {
      outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor} !important; //#bfc7de  
        outline-offset: ${props => 5 - props.theme.lineWidthFocus}px;
    }
  }
  .ant-pagination {// Paginazione
    .ant-pagination-item,
    .ant-pagination-prev:not(:disabled),
    .ant-pagination-next:not(:disabled) { 
      &:focus-visible {
          outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor} !important; //#bfc7de  
          outline-offset: 1px;
      }
    }
  }
  .ant-checkbox .ant-checkbox-input:focus-visible+.ant-checkbox-inner,
  .ant-radio-wrapper .ant-radio-input:focus-visible+.ant-radio-inner {
    outline-color: ${props => props.theme.focusOutlineColor};
  }
  // Stile per il focus sugli elementi della select
  .ant-select-item.ant-select-item-option {
    &.ant-select-item-option-active {
      outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor}; //#bfc7de  
  outline-offset: -2px;
    }
  
  }
  .ant-drawer .ant-drawer-close {
    &:focus-visible {
      outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor}; //#bfc7de
  outline-offset: 1px;
  border-radius: ${props => props.theme.borderRadius}px;
      }
  }
   // accessibilità menu
  .ant-menu-root:focus-visible,
  .ant-menu-submenu-title:not(.ant-menu-item-disabled):focus-visible,
  .ant-menu-item:not(.ant-menu-item-disabled):focus-visible {
    outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor} !important;
  border-radius: ${props => props.theme.borderRadius}px;
  }

  // Accessibilità per pulsante copia Text
  .ant-typography-copy {
    &:focus-visible {
        outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor}; //#bfc7de
    border-radius: ${props => props.theme.borderRadius}px;
    outline-offset: 2px;
    }
  }
  
  // Overwrite singoli elementi
  body {
    .ant-breadcrumb a:focus-visible {
      outline-offset: 0;
    }
    .ant-tabs .ant-tabs-tab {
      .ant-tabs-tab-btn:focus-visible {
        border-radius: ${props => props.theme.borderRadius}px;
      }
      &:first-child {
        .ant-tabs-tab-btn:focus-visible {
          // per mostrare completamente il bordo dell'outline
          margin-left: 5px;
          margin-right: -5px;
        }
      }
    }

    a:focus-visible {
      outline-offset: 3px;
      outline: ${props => props.theme.lineWidthFocus}px solid ${props =>
  props.theme.focusOutlineColor};
    }
  }

  // Correggiamo, per la select, la visibilità dell'icona di clear
  // In modo che sia sempre visibile e posizionata correttamente
  body .ant-select {
    &:hover .ant-select-arrow:not(:last-child) {
      opacity: 1;
    }

    &.ant-select-has-feedback .ant-select-clear {
      inset-inline-end: 52px;
    }

    &:hover .ant-select-clear {
      opacity: 1;
    }

    .ant-select-clear {
      opacity: 0.7;
      inset-inline-end: 30px;
    }

    // Compensiamo il padding DX per i Tag selezionati, per evitare che si
    // sovrappongano all'icona di clear
    &.ant-select-multiple.ant-select-allow-clear .ant-select-selector {      
      padding-inline-end: 80px;
    }

  }

  /**
  * Permette i testi opzione della Select di Ant su più righe
  * (da usare in caso di testi lunghi)
  *
  * La classe 'full-text-options' può essere assegnata alle option della select
  *
  * @example
  * options={options.map(option => ({
  *  className: 'full-text-options',
  *  label: ...,
  *  value: ...
  * }))}

  * Oppure all'intera lista di opzioni
  * inserendo la classe 'full-text-options' nella proprietà rootClassName="full-text-options"
  * Attenzione in caso di liste virtualizzate, in cui l'altezza degli elementi può diventare un problema
  */
  body .full-text-options {
    &.multi-preference-options{
      .ant-select-item-option-content{
      max-width: 350px;  
      ${down('sm')} {
            max-width: 180px; 
      }
    }}
    .ant-select-item-option-content {
      flex: auto;
      overflow: unset;
      white-space: normal;
      text-overflow: unset;
    }
    &.ant-select-multiple {
      .ant-select-selection-item {
        height: auto;
        padding-top: 2px;
        padding-bottom: 2px;
        line-height: 1.3;
      }
      .ant-select-selection-overflow
      .ant-select-selection-item-content {
        /* flex: auto; */
        white-space: normal;
        text-overflow: unset;
        overflow: unset;
      }
    }
  }
  /**
  * Gestiamo gli accapo inseriti manualmente con l'RTE nelle opzioni della Select
  * eliminando dalla visualizzazione il tag <br> e lasciando solo il testo 
  * quando l'opzione è selezionata
  */
  body .ant-select {
    .ant-select-selection-item {
    br {
      display: none;
    }
  }
}

  // Accessibilità per il PopConfirm. Dato che ridisegniamo il contenuto,
  // dobbiamo rimuovere gli spazi.
  .confirm-button__popconfirm {
    .ant-popconfirm-message {
      margin: 0;
      // modifichiamo anche il colore dell'icona
      >.ant-popconfirm-message-icon .anticon {
        color : ${props => props.theme.colorError};
      }
    }
  }

  // Testi SR-only
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  // Nascondiamo l'asterisco per i campi richiesti per gli
  // screen reader, utilizzando il testo alternativo CSS
  // Vedi: https://a11ysupport.io/tests/tech__css__css_generated_content_alt
  body .ant-form-item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    content: '*' / ' ';
  }

  .no-padding-dropdown-overlay {
    padding: 0;
    margin: 0;
    .ant-dropdown-menu {
      padding: 0;
      width: 100%;
      .ant-dropdown-menu-item {
        padding: 0;
        width: 100%;
      }
    }
  }

`;
